import { render, staticRenderFns } from "./AddWeight.vue?vue&type=template&id=be9fb188&scoped=true"
import script from "./AddWeight.vue?vue&type=script&lang=js"
export * from "./AddWeight.vue?vue&type=script&lang=js"
import style0 from "./AddWeight.vue?vue&type=style&index=0&id=be9fb188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9fb188",
  null
  
)

export default component.exports